module.exports = __webpack_public_path__ + "static/media/slide-4.8193d311.jpg";